import instance from '../../../api/axios'

export const loadServerDiscInfo = async (): Promise<any> => {
  const response = await instance.get('/files/disk-info')

  return response.data
}

export default loadServerDiscInfo
